export default __webpack_public_path__ + "static/media/airdockz-cbb-banner-1.489e8f28.jpg";